class ProgressivePagingService {
    constructor() {
        this.onProgressChanged = null;


        this.registeredListener = null;

        this.addListener = function(id, onProgressChanged) {
            this.registeredListener = id;
            this.onProgressChanged = onProgressChanged;
        };

        this.clearListener = function(id) {
            if (this.registeredListener === id || !this.registeredListener) {
                this.onProgressChanged = null;
                this.registeredListener = null;
            }
        };

        this.updateProgress = function (loadedCount, totalCount) {

            if (this.onProgressChanged != null) {
                this.onProgressChanged({ loadedCount, totalCount });
            }
        };
    }
}

module.exports = ProgressivePagingService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/paging/progressive-paging-service.js
 **/